module.exports = __webpack_public_path__ + "img/after3-Recovered.1128179b.png";